import { render } from "./App.vue?vue&type=template&id=e9033fea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e9033fea&lang=css"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__